import { forwardRef, type InputHTMLAttributes } from "react";
import { cn } from "../../lib/utils";

export interface SliderProps
  extends Omit<InputHTMLAttributes<HTMLInputElement>, "type" | "onChange"> {
  value: number;
  min?: number;
  max?: number;
  step?: number;
  onValueChange?: (value: number) => void;
}

export const Slider = forwardRef<HTMLInputElement, SliderProps>(
  ({ className, value, min = 0, max = 100, step = 1, onValueChange, ...rest }, ref) => {
    return (
      <input
        ref={ref}
        type="range"
        value={value}
        min={min}
        max={max}
        step={step}
        onChange={(e) => onValueChange?.(Number(e.currentTarget.value))}
        className={cn(
          "h-2 w-full cursor-pointer appearance-none rounded-full bg-[color:var(--surface-2)] accent-[color:var(--primary)]",
          "focus:outline-none focus-visible:ring-2 focus-visible:ring-[color:var(--primary)] focus-visible:ring-offset-2",
          className,
        )}
        {...rest}
      />
    );
  },
);
Slider.displayName = "Slider";
